// extracted by mini-css-extract-plugin
export default {"actrulehead":"Acts_actrulehead__ZIuzY"};